<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right page-consumption-terminal">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表：表头与内容统一居中。最后修改：2026-08-07 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" ref="table" class="custom-tbl consumption-terminal-table"
        height="100%" style="width: 100%" @selection-change="handleSelectionChange" @row-click="handleTableRowClick">
        <el-table-column type="selection" width="46" align="center"> </el-table-column>

        <el-table-column label="终端" min-width="140" align="center">
          <template slot-scope="{ row }">
            <div class="cell-block">
              <div class="cell-main" :title="terminalPrimary(row)">{{ terminalPrimary(row) }}</div>
              <div v-if="terminalShowTwoLines(row)" class="cell-meta" :title="row.KqTerminalId">{{ row.KqTerminalId }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="模式" min-width="160" align="center">
          <template slot-scope="{ row }">
            <div v-for="m in [getConsumptionModeMeta(row)]" :key="'cm-' + row.Id" class="tag-row">
              <template v-if="m.modeLabel">
                <el-tag :type="m.modeType" size="mini" effect="light" disable-transitions>{{ m.modeLabel }}</el-tag>
                <el-tag v-if="m.subsidyLabel || m.amountLabel" type="info" effect="light" size="mini"
                  class="mode-tag-sub" disable-transitions>{{ consumptionModeSubText(m) }}</el-tag>
              </template>
              <span v-else class="cell-meta">—</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="专项优先" width="100" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-if="showSubsidyScopeFields(row.TouchTypeDirection)"
              :value="rowPrioritizeSubsidy(row)"
              :disabled="!!row._prioritizeSaving"
              inactive-color="#dcdfe6"
              @change="(v) => onInlinePrioritizeChange(row, v)" />
            <span v-else class="cell-meta">—</span>
          </template>
        </el-table-column>

        <el-table-column label="部门 / 位置" min-width="150" align="center">
          <template slot-scope="{ row }">
            <div class="cell-block">
              <div class="cell-main" :title="deptLocationPrimary(row)">{{ deptLocationPrimary(row) }}</div>
              <div v-if="deptLocationShowTwoLines(row)" class="cell-meta" :title="row.InstallAddress || ''">{{ row.InstallAddress || '未填位置' }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="IsOnLine" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsOnLine == 1 ? 'success' : 'info'" size="mini" effect="light"
              disable-transitions>{{ scope.row.IsOnLine == 1 ? "在线" : "离线" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="TerminalDesc" label="备注" min-width="100" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" min-width="160" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="96" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="op-link"
              @click.stop="openSyncLogDialog(scope.row)">同步日志</el-button>
          </template>
        </el-table-column>

      </el-table>
      </div>
      <!--工具条-->

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close width="720px">
        <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm" class="terminal-dialog-form">

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="终端标识" prop="KqTerminalId">
                <el-input v-model="editForm.KqTerminalId" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端名称" prop="TerminalName">
                <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="安装位置" prop="InstallAddress">
                <el-input v-model="editForm.InstallAddress" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消费模式" prop="TouchTypeDirection">
                <el-select v-model="editForm.TouchTypeDirection" placeholder="请选择终端模式" style="width: 100%">
                  <el-option label="自由模式" value="1"></el-option>
                  <el-option label="限次模式" value="2"></el-option>
                  <el-option label="时间段消费模式" value="3"></el-option>
                  <el-option label="固定金额模式" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="editForm.TouchTypeDirection === '1' || editForm.TouchTypeDirection === '3'">
            <el-col :span="12">
              <el-form-item label="补贴类型" prop="SubsidyMode">
                <el-select v-model="editForm.SubsidyMode" placeholder="请选择补贴类型" style="width: 100%">
                  <el-option label="无限制" value=""></el-option>
                  <el-option label="不启用补贴" value="3"></el-option>
                  <el-option label="启用学生补贴" value="1"></el-option>
                  <el-option label="启用老师补贴" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="showSubsidyScopeFields(editForm.TouchTypeDirection)" :gutter="16">
            <el-col :span="12">
              <el-form-item label="优先扣专项">
                <el-switch v-model="editForm.prioritizeSubsidyBalance" :active-value="true" :inactive-value="false" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专项分组范围">
                <el-select :key="'edit-sg-' + editSubsidySelectKey"
                  v-model="editForm.subsidyGroupIdList" multiple clearable style="width:100%"
                  placeholder="不选表示全部分组">
                  <el-option v-for="g in consumptiveGroupOptions" :key="g.Id" :label="g.GroupName" :value="g.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="editForm.TouchTypeDirection == '4'">
            <el-col :span="12">
              <el-form-item class="terminal-form-item--fixed-amount-label">
                <template slot="label">
                  <span class="terminal-fixed-amount-label">固定金额模式<br />金额</span>
                </template>
                <el-input-number v-model="editForm.InstallPosition" :min="1" :step="1" style="width: 100%" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item label="设备说明">
                <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close width="720px">
        <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm"
          class="demo-form-inline terminal-dialog-form">

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="终端标识" prop="KqTerminalId">
                <el-input v-model="addForm.KqTerminalId" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端名称" prop="TerminalName">
                <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="安装位置" prop="InstallAddress">
                <el-input v-model="addForm.InstallAddress" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终端模式" prop="TouchTypeDirection">
                <el-select v-model="addForm.TouchTypeDirection" placeholder="请选择终端模式" style="width: 100%">
                  <el-option label="自由模式" value="1"></el-option>
                  <el-option label="限次模式" value="2"></el-option>
                  <el-option label="时间段消费模式" value="3"></el-option>
                  <el-option label="固定金额模式" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="addForm.TouchTypeDirection === '1' || addForm.TouchTypeDirection === '3'">
            <el-col :span="12">
              <el-form-item label="补贴类型" prop="SubsidyMode">
                <el-select v-model="addForm.SubsidyMode" placeholder="请选择补贴类型" style="width: 100%">
                  <el-option label="无限制" value=""></el-option>
                  <el-option label="不启用补贴" value="3"></el-option>
                  <el-option label="启用学生补贴" value="1"></el-option>
                  <el-option label="启用老师补贴" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="showSubsidyScopeFields(addForm.TouchTypeDirection)" :gutter="16">
            <el-col :span="12">
              <el-form-item label="优先扣专项">
                <el-switch v-model="addForm.prioritizeSubsidyBalance" :active-value="true" :inactive-value="false" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="专项分组范围">
                <el-select :key="'add-sg-' + addSubsidySelectKey"
                  v-model="addForm.subsidyGroupIdList" multiple clearable style="width:100%"
                  placeholder="不选表示全部分组">
                  <el-option v-for="g in consumptiveGroupOptions" :key="g.Id" :label="g.GroupName" :value="g.Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16" v-if="addForm.TouchTypeDirection == '4'">
            <el-col :span="12">
              <el-form-item class="terminal-form-item--fixed-amount-label">
                <template slot="label">
                  <span class="terminal-fixed-amount-label">固定金额模式<br />金额</span>
                </template>
                <el-input-number v-model="addForm.InstallPosition" :min="1" :step="1" style="width: 100%" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item label="设备说明">
                <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 同步/删除人员：家校/内部通讯录 + 右侧人员表。最后更新：2026-09-15 -->
      <el-dialog
        :title="personScopeMode === 'delete' ? '删除人员' : '同步人员'"
        :visible.sync="personScopeVisible"
        :close-on-click-modal="false"
        destroy-on-close
        append-to-body
        width="1100px"
        top="6vh"
        custom-class="person-scope-dialog"
        @close="resetPersonScopeDialog">
        <div class="ps-layout" v-loading="personScopeTreeLoading">
          <div class="ps-left">
            <div class="ps-left-header">
              <i class="el-icon-office-building"></i>
              <span>选择机构 / 学校</span>
            </div>
            <div class="ps-scope-bar">
              <button
                type="button"
                class="ps-scope-btn"
                :class="{ 'is-active': personScopeDirectoryScope === 'teaching' }"
                @click="setPersonScopeDirectory('teaching')">
                <i class="el-icon-reading"></i> 家校通讯录
              </button>
              <button
                type="button"
                class="ps-scope-btn"
                :class="{ 'is-active': personScopeDirectoryScope === 'internal' }"
                @click="setPersonScopeDirectory('internal')">
                <i class="el-icon-office-building"></i> 内部通讯录
              </button>
            </div>
            <div class="ps-left-search">
              <el-input
                v-model="personScopeDeptFilter"
                clearable
                size="small"
                prefix-icon="el-icon-search"
                placeholder="输入关键字搜索机构/学校..." />
            </div>
            <div class="ps-left-tree">
              <el-tree
                v-show="personScopeDirectoryScope === 'teaching'"
                ref="personScopeTeachingTree"
                :data="personScopeTeachingTree"
                node-key="value"
                highlight-current
                :expand-on-click-node="false"
                :props="personScopeTreeProps"
                :filter-node-method="filterPersonScopeDeptNode"
                :default-expanded-keys="personScopeTeachingExpandedKeys"
                @node-click="onPersonScopeDeptClick">
                <span class="ps-tree-node" slot-scope="{ node, data }">
                  <span class="ps-tree-node__dot" :class="'tone-' + personScopeNodeTone(data)"></span>
                  <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <el-tree
                v-show="personScopeDirectoryScope === 'internal'"
                ref="personScopeInternalTree"
                :data="personScopeInternalTree"
                node-key="value"
                highlight-current
                :expand-on-click-node="false"
                :props="personScopeTreeProps"
                :filter-node-method="filterPersonScopeDeptNode"
                :default-expanded-keys="personScopeInternalExpandedKeys"
                @node-click="onPersonScopeDeptClick">
                <span class="ps-tree-node" slot-scope="{ node, data }">
                  <span class="ps-tree-node__dot" :class="'tone-' + personScopeNodeTone(data)"></span>
                  <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <div
                v-if="!personScopeTreeLoading && personScopeCurrentTreeEmpty"
                class="ps-empty">
                暂无部门
              </div>
            </div>
          </div>

          <div class="ps-right">
            <el-alert
              :title="personScopeMode === 'delete'
                ? '可按部门或个人删除终端人员；删除不要求有头像'
                : '目前只下发有头像的人员，无头像自动过滤'"
              :type="personScopeMode === 'delete' ? 'warning' : 'info'"
              show-icon
              :closable="false"
              class="ps-alert" />

            <div class="ps-meta">
              已选终端：<strong>{{ multipleSelection.length }}</strong> 台
              <span class="ps-meta-sep">·</span>
              已选人员：<strong>{{ personScopeCheckedCount }}</strong> 人
              <span class="ps-meta-sep">·</span>
              涉及部门：<strong>{{ personScopeDeptCount }}</strong> 个
            </div>

            <div class="ps-filter-bar">
              <el-input
                v-model="personScopeNameFilter"
                clearable
                size="small"
                prefix-icon="el-icon-search"
                placeholder="姓名"
                class="ps-name-input"
                @keyup.enter.native="loadPersonScopePeople" />
              <el-select
                v-if="personScopeDirectoryScope === 'teaching'"
                v-model="personScopeLiveTypeFilter"
                clearable
                filterable
                size="small"
                placeholder="人员类型"
                class="ps-type-select"
                :disabled="!personScopeLiveTypeOptions.length && !personScopeLiveTypeLoading"
                :loading="personScopeLiveTypeLoading"
                @change="onPersonScopeLiveTypeFilterChange"
              >
                <el-option label="全部类型" value="" />
                <el-option
                  v-for="t in personScopeLiveTypeOptions"
                  :key="t.LiveTypeId"
                  :label="t.LiveTypeName || t.LiveTypeId"
                  :value="t.LiveTypeId"
                />
              </el-select>
              <el-button type="primary" size="small" :disabled="!personScopeActiveDeptId" @click="loadPersonScopePeople">
                查询
              </el-button>
              <el-button size="small" @click="selectAllPersonScopeCurrentDept" :disabled="!personScopeActiveDeptId || !personScopeTableRows.length">
                全选当前部门
              </el-button>
              <el-button size="small" @click="clearPersonScopeCurrentDept" :disabled="!personScopeActiveDeptId">
                清空当前部门
              </el-button>
              <el-button size="small" type="text" @click="clearPersonScopeSelection" :disabled="personScopeCheckedCount === 0">
                清空全部已选
              </el-button>
            </div>

            <div class="ps-hint" v-if="personScopeActiveDeptId">
              当前部门：<strong>{{ personScopeActiveDeptName }}</strong>
              <span class="ps-hint-sub">（{{ personScopeDirectoryScope === 'teaching' ? '家校' : '内部' }} · {{ personScopeTableRows.length }} 人）</span>
            </div>
            <div class="ps-hint ps-hint--warn" v-else>
              请先在左侧选择部门
            </div>

            <div class="ps-table-wrap" ref="personScopeTableWrap" v-loading="personScopeTableLoading">
              <el-table
                ref="personScopeTable"
                :data="personScopePagedRows"
                row-key="value"
                size="small"
                stripe
                highlight-current-row
                :height="personScopeTableHeight"
                @row-click="onPersonScopeRowClick"
                @selection-change="onPersonScopeTableSelectionChange">
                <el-table-column type="selection" width="46" align="center" />
                <el-table-column prop="label" label="姓名" min-width="110" show-overflow-tooltip />
                <el-table-column label="类型" min-width="100" align="center">
                  <template slot-scope="scope">
                    <span class="ps-type-tag" :class="'ps-type-tag--' + personScopeRowTypeTone(scope.row)">
                      {{ personScopeRowTypeLabel(scope.row) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="deptLabel" label="部门" min-width="140" show-overflow-tooltip />
                <el-table-column label="头像" width="72" align="center" header-align="center">
                  <template slot-scope="scope">
                    <oss-media-thumbs
                      v-if="scope.row.HeadPhotoImage"
                      :media="scope.row.HeadPhotoImage"
                      thumb-width="40px"
                      thumb-height="40px"
                    />
                    <span v-else class="ps-avatar-empty">无</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="ps-pager-wrap">
              <el-pagination
                layout="total, prev, pager, next, jumper"
                :page-size="personScopePageSize"
                :total="personScopeTableRows.length"
                :current-page="personScopePage"
                @current-change="handlePersonScopePageChange" />
            </div>

            <div class="ps-actions">
              <el-button @click="personScopeVisible = false">取消</el-button>
              <el-button
                :type="personScopeMode === 'delete' ? 'danger' : 'warning'"
                :loading="addLoading"
                @click="submitPersonScopeAll">
                {{ personScopeMode === 'delete' ? '全部清空' : '全量同步' }}
              </el-button>
              <el-button
                type="primary"
                :loading="addLoading"
                :disabled="personScopeCheckedCount === 0"
                @click="submitPersonScopeSelected">
                {{ personScopeMode === 'delete' ? '删除选中' : '同步选中' }}（{{ personScopeCheckedCount }}）
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 同步日志弹窗 -->
      <el-dialog title="同步日志" :visible.sync="syncLogVisible" width="60%" :close-on-click-modal="false"
        @close="resetSyncLogDialog">
        <el-form class="sync-log-filter-form" :inline="true" size="small" style="margin-bottom: 10px;">
          <el-form-item label="人员">
            <el-input v-model="syncLogSearch.UserName" placeholder="输入人员姓名" clearable
              @keyup.enter.native="fetchSyncLog" />
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="syncLogSearch.Way" placeholder="全部" clearable style="width: 110px">
              <el-option label="全部" value=""></el-option>
              <el-option label="同步" value="0"></el-option>
              <el-option label="删除" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="syncLogSearch.Status" placeholder="全部" clearable style="width: 120px">
              <el-option label="全部" value=""></el-option>
              <el-option label="成功" value="成功"></el-option>
              <el-option label="失败" value="失败"></el-option>
              <el-option label="待同步" value="待同步"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="sync-log-form-actions-lead">
            <el-button type="primary" @click="fetchSyncLog">搜索</el-button>
            <el-button @click="resetSyncLogSearch">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-download" @click="handleExportSyncLog">导出日志</el-button>
            <el-button type="danger" @click="handleClearSyncLog">清空同步日志</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="syncLogList" v-loading="syncLogLoading" style="width: 100%">
          <el-table-column prop="UserName" label="人员" min-width="100"></el-table-column>
          <el-table-column label="类型" width="80" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.Way === '2' ? 'danger' : 'primary'" size="mini" effect="light" disable-transitions>
                {{ formatSyncLogWay(scope.row.Way) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="Status" label="状态" width="90"></el-table-column>
          <el-table-column prop="FailReason" label="失败原因" min-width="120" />
          <el-table-column prop="CreateTime" label="下发时间" min-width="150" />
          <el-table-column prop="UpdateTime" label="回调时间" min-width="150" />
        </el-table>
        <!-- 不用 el-col + float，避免分页脱离 dialog 白底；与主列表同为默认尺寸 pagination -->
        <div class="toolbar sync-log-pager-wrap" style="width: 100%">
          <el-pagination layout="total, prev, pager, next" :page-size="syncLogPageSize" :total="syncLogTotal"
            :current-page="syncLogPage" @current-change="handleSyncLogPageChange" />
        </div>
      </el-dialog>

    </section>
  </section>
</template>
<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getKqtDeviceTerminalListPage, removeKqtDeviceTerminal, editKqtDeviceTerminal, addKqtDeviceTerminal, getSyncUserRecords, exportSyncUserRecords, clearSyncUserRecords } from '../../api/modules/attendance';
import { getTeachingDepartmentTree, getInternalDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { syucUser, getSubsidyStudentGroupList } from '../../api/modules/consumption';
import { getStudentSelectList, getTeacherMasterListPage } from '../../api/modules/personnel';
import { fetchStudentLiveTypesByDeptId } from '../../utils/studentLiveType';
import {
  lockPersonScopeSelectionSync,
  syncPersonScopeElTableSelection,
} from '../../utils/personScopeTableSelection';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import { normalizeDeptId } from '../../utils/deptCascaderProps';
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
          width: '140px',
        },
        {
          label: '序列号',
          key: 'kqTerminalId',
          width: '160px',
          placeholder: '终端标识/序列号'
        },
        {
          label: '消费模式',
          key: 'consumptionMode',
          type: 'select',
          width: '130px',
          options: [{
            label: '全部',
            value: ''
          },{
            label: '自由模式',
            value: '1'
          }, {
            label: '限次模式',
            value: '2'
          }, {
            label: '时间段消费模式',
            value: '3'
          }, {
            label: '固定金额模式',
            value: '4'
          }]
        },
        {
          label: '状态',
          key: 'isOnLine',
          type: 'select',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '在线', value: '1' },
            { label: '离线', value: '0' }
          ]
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        InstallPosition: "",
        SubsidyMode: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "1",
        InstallAddress: "",
        prioritizeSubsidyBalance: false,
        subsidyGroupIdList: [],
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        KqTerminalId: [
          { required: true, message: "请输入终端标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "",
        TerminalDesc: "",
        InstallPosition: "",
        SubsidyMode: "",
        Dids: [],
        DepartmentId: 0,
        TerminalTypeId: "1",
        InstallAddress: "",
        prioritizeSubsidyBalance: false,
        subsidyGroupIdList: [],
      },
      consumptiveGroupOptions: [],
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      multipleSelection: [],

      // 同步/删除人员：家校/内部通讯录。最后更新：2026-09-15
      personScopeVisible: false,
      personScopeMode: 'sync', // sync | delete
      personScopeDirectoryScope: 'teaching',
      personScopeTeachingTree: [],
      personScopeInternalTree: [],
      personScopeTeachingExpandedKeys: [],
      personScopeInternalExpandedKeys: [],
      personScopeTreeLoading: false,
      personScopeDeptFilter: '',
      personScopeNameFilter: '',
      /** 同步选人：人员类型筛选。最后更新：2026-10-29 */
      personScopeLiveTypeFilter: '',
      personScopeLiveTypeOptions: [],
      personScopeLiveTypeLoading: false,
      personScopeTreeProps: { children: 'children', label: 'label' },
      personScopeActiveDeptId: '',
      personScopeActiveDeptName: '',
      personScopeTableRows: [],
      personScopeTableLoading: false,
      personScopePage: 1,
      personScopePageSize: 10,
      personScopeTableHeight: 400,
      personScopeSelectedMap: {},
      personScopeSyncingTable: false,
      personScopeCheckedCount: 0,
      personScopeDeptCount: 0,
      // 同步日志弹窗相关
      syncLogVisible: false,
      syncLogList: [],
      syncLogLoading: false,
      syncLogPage: 1,
      syncLogPageSize: 10,
      syncLogTotal: 0,
      syncLogDeviceNo: '',
      syncLogSearch: {
        UserName: '',
        Status: '',
        Way: ''
      },
      /** 专项分组多选：变更后强制重挂，避免 Element 在弹窗+异步选项下内部状态卡住 */
      editSubsidySelectKey: 0,
      addSubsidySelectKey: 0,
    };
  },
  methods: {
    parseConsumptiveGroupIdList(s) {
      if (s == null || s === '') return [];
      return String(s)
        .split(',')
        .map((x) => String(x).trim())
        .filter((x) => x.length > 0);
    },
    /** 与下拉选项 g.Id 类型一致，避免多选因 string/number 与异步选项不同步点不中 */
    alignSubsidyGroupIdsToOptions(parsedIds) {
      const opts = this.consumptiveGroupOptions || [];
      const ids = parsedIds || [];
      if (!opts.length || !ids.length) return [];
      const out = [];
      for (const p of ids) {
        const hit = opts.find((g) => {
          const gid = g.Id != null ? g.Id : g.id;
          return String(gid) === String(p);
        });
        if (hit) out.push(hit.Id != null ? hit.Id : hit.id);
      }
      return out;
    },
    async loadConsumptiveGroupOptions(deptId) {
      const id = normalizeDeptId(deptId) || normalizeDeptId(this.DepartmentId);
      if (!id) {
        this.consumptiveGroupOptions = [];
        return;
      }
      try {
        const res = await getSubsidyStudentGroupList({ departmentId: id });
        if (res.data && res.data.success)
          this.consumptiveGroupOptions = res.data.response || [];
        else
          this.consumptiveGroupOptions = [];
      } catch (e) {
        this.consumptiveGroupOptions = [];
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /** 列表「消费模式」标签展示 */
    getConsumptionModeMeta(row) {
      const td = row.TouchTypeDirection == null ? '' : String(row.TouchTypeDirection);
      const sm = row.SubsidyMode;
      let subsidyLabel = '';
      if (td === '1' || td === '3') {
        if (sm === '' || sm == null) subsidyLabel = '无限制';
        else if (sm === '1') subsidyLabel = '学生补贴';
        else if (sm === '2') subsidyLabel = '老师补贴';
        else if (sm === '3') subsidyLabel = '不启用补贴';
      }
      if (td === '1') {
        return { modeLabel: '自由模式', modeType: 'success', subsidyLabel, amountLabel: '' };
      }
      if (td === '2') {
        return { modeLabel: '限次模式', modeType: 'info', subsidyLabel: '', amountLabel: '' };
      }
      if (td === '3') {
        return { modeLabel: '时间段消费模式', modeType: 'warning', subsidyLabel, amountLabel: '' };
      }
      if (td === '4') {
        const ip = row.InstallPosition;
        const amountLabel = ip ? `${ip} 元` : '';
        return { modeLabel: '固定金额模式', modeType: 'danger', subsidyLabel: '', amountLabel };
      }
      return { modeLabel: '', modeType: 'info', subsidyLabel: '', amountLabel: '' };
    },
    consumptionModeSubText(m) {
      return [m.subsidyLabel, m.amountLabel].filter(Boolean).join(' ');
    },
    /** 编号与名称相同或缺一时不重复两行 */
    terminalShowTwoLines(row) {
      const id = (row.KqTerminalId || '').trim();
      const name = (row.TerminalName || '').trim();
      if (!id && !name) return false;
      if (!id || !name) return false;
      return id !== name;
    },
    /** 终端主行：优先名称，否则编号 */
    terminalPrimary(row) {
      const id = (row.KqTerminalId || '').trim();
      const name = (row.TerminalName || '').trim();
      return name || id || '—';
    },
    /** 有位置且与部门不同时显示第二行 */
    deptLocationShowTwoLines(row) {
      const d = (row.DepartmentName || '').trim();
      const a = (row.InstallAddress || '').trim();
      return !!(d && a && a !== d);
    },
    /** 部门/位置主行 */
    deptLocationPrimary(row) {
      const d = (row.DepartmentName || '').trim();
      const a = (row.InstallAddress || '').trim();
      if (d) return d;
      return a || '—';
    },
    rowPrioritizeSubsidy(row) {
      return row.prioritizeSubsidyBalance === true || row.prioritizeSubsidyBalance === 1
        || row.PrioritizeSubsidyBalance === true || row.PrioritizeSubsidyBalance === 1;
    },
    /** 限次模式(2)不适用优先扣专项、专项分组 */
    showSubsidyScopeFields(touchTypeDirection) {
      return String(touchTypeDirection || '') !== '2';
    },
    buildTerminalPutPayloadFromListRow(row, prioritizeSubsidyBalance) {
      const para = Object.assign({}, row);
      delete para._prioritizeSaving;
      para.PrioritizeSubsidyBalance = !!prioritizeSubsidyBalance;
      const gid = row.subsidyGroupIds != null && row.subsidyGroupIds !== ''
        ? String(row.subsidyGroupIds)
        : (row.SubsidyGroupIds != null ? String(row.SubsidyGroupIds) : '');
      para.SubsidyGroupIds = gid;
      if (Array.isArray(para.Dids) && para.Dids.length > 0) {
        para.DepartmentId = para.Dids[para.Dids.length - 1];
      }
      return para;
    },
    onInlinePrioritizeChange(row, val) {
      this.$set(row, '_prioritizeSaving', true);
      const para = this.buildTerminalPutPayloadFromListRow(row, val);
      editKqtDeviceTerminal(para).then((res) => {
        if (util.isEmt.format(res)) {
          this.$set(row, '_prioritizeSaving', false);
          return;
        }
        this.$set(row, '_prioritizeSaving', false);
        if (res.data.success) {
          this.$set(row, 'prioritizeSubsidyBalance', val);
          this.$set(row, 'PrioritizeSubsidyBalance', val);
          this.$message.success(res.data.msg || '已更新');
        } else {
          this.$message.error(res.data.msg || '更新失败');
          this.$forceUpdate();
        }
      }).catch(() => {
        this.$set(row, '_prioritizeSaving', false);
        this.$message.error('保存失败');
        this.$forceUpdate();
      });
    },

    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    /** 点击行切换勾选（可多选、再点同一行取消）；操作列、开关、勾选框不抢焦点 */
    handleTableRowClick(row, column, event) {
      if (!row || !this.$refs.table) return;
      const t = event && event.target;
      if (t && typeof t.closest === 'function') {
        if (t.closest('.el-checkbox')) return;
        if (t.closest('.el-switch')) return;
        if (t.closest('button') || t.closest('.el-button')) return;
      }
      if (column && column.label === '操作') return;
      const selected = (this.multipleSelection || []).some((r) => r.Id === row.Id);
      this.$refs.table.toggleRowSelection(row, !selected);
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    // 打开同步日志弹窗
    openSyncLogDialog(row) {
      this.syncLogDeviceNo = row.KqTerminalId;
      this.syncLogPage = 1;
      this.syncLogVisible = true;
      this.fetchSyncLog();
    },

    // 获取同步日志数据
    fetchSyncLog() {
      this.syncLogLoading = true;
      getSyncUserRecords({
        deviceSerialNo: this.syncLogDeviceNo,
        page: this.syncLogPage,
        intPageSize: this.syncLogPageSize,
        status: this.syncLogSearch.Status,
        userName: this.syncLogSearch.UserName,
        way: this.syncLogSearch.Way
      }).then(res => {
        const data = res.data.response;
        this.syncLogList = data.data || [];
        this.syncLogTotal = data.dataCount || 0;
        this.syncLogLoading = false;
      }).catch(() => {
        this.syncLogLoading = false;
      });
    },
    resetSyncLogSearch() {
      this.syncLogSearch = { UserName: '', Status: '', Way: '' };
      this.fetchSyncLog();
    },
    // 分页切换
    handleSyncLogPageChange(page) {
      this.syncLogPage = page;
      this.fetchSyncLog();
    },

    // 关闭弹窗时重置
    resetSyncLogDialog() {
      this.syncLogList = [];
      this.syncLogPage = 1;
      this.syncLogTotal = 0;
      this.syncLogDeviceNo = '';
      this.syncLogSearch = { UserName: '', Status: '', Way: '' };
    },

    /** 同步日志类型文案。最后更新：2026-09-15 */
    formatSyncLogWay(way) {
      return way === '2' ? '删除' : '同步';
    },

    // 导出同步日志
    handleExportSyncLog() {
      const params = {
        deviceSerialNo: this.syncLogDeviceNo,
        status: this.syncLogSearch.Status,
        userName: this.syncLogSearch.UserName,
        way: this.syncLogSearch.Way
      };
      exportSyncUserRecords(params).then(res => {
        // 假设后端返回的是文件流
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.syncLogDeviceNo + '同步日志.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
    },
    // 清空同步日志
    handleClearSyncLog() {
      this.$confirm('确定要清空当前终端的所有同步日志吗？此操作不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.syncLogLoading = true;
        clearSyncUserRecords({
          id: this.syncLogDeviceNo
        }).then(res => {
          this.$message.success(res.data.response);
          this.fetchSyncLog(); // 清空后重新加载日志列表
        }).catch(() => {
          this.syncLogLoading = false;
          this.$message.error(res.data.response);
        });
      }).catch(() => {
        this.$message.info('已取消清空操作');
      });
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: "1"
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getKqtDeviceTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择要删除的一行数据！',
          type: 'error',
        })
        return
      }

      var row = rows[0];

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeKqtDeviceTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    async handleEdit() {
      var rows = this.multipleSelection
      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }
      var row = rows[0];
      this.options = [];
      await this.loadConsumptiveGroupOptions(row.DepartmentId);
      const parsed = this.parseConsumptiveGroupIdList(row.subsidyGroupIds || row.SubsidyGroupIds);
      const aligned = this.alignSubsidyGroupIdsToOptions(parsed);
      this.editForm = Object.assign({}, row);
      // 优先使用当前终端绑定的所属学校ID，若无则使用当前页面统一选中的 ID 兜底
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
      // 列表行常为 PascalCase；对 editForm 新加 the camelCase 字段须 $set 才能在 Vue2 下响应
      this.$set(this.editForm, 'prioritizeSubsidyBalance', this.rowPrioritizeSubsidy(row));
      this.editFormVisible = true;
      await this.$nextTick();
      this.$set(this.editForm, 'subsidyGroupIdList', aligned.slice());
      await this.$nextTick();
      this.editSubsidySelectKey += 1;
    },
    //显示新增界面
    async handleAdd() {
      // 限制：必须先在左侧选择具体的学校机构才能进行新增
      if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
        this.$message.warning("请先在左侧选择具体的学校机构！");
        return;
      }
      this.options = [];
      await this.loadConsumptiveGroupOptions(this.DepartmentId);
      this.addForm = {
        KqTerminalId: "",
        TerminalName: "",
        TouchTypeDirection: "1",
        TerminalDesc: "",
        InstallPosition: "",
        SubsidyMode: "",
        Dids: [],
        DepartmentId: this.DepartmentId, // 直接使用当前页面统一选中的学校ID
        TerminalTypeId: "1",
        InstallAddress: "",
        prioritizeSubsidyBalance: false,
        subsidyGroupIdList: [],
      };
      this.addFormVisible = true;
      await this.$nextTick();
      this.addSubsidySelectKey += 1;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            delete para.subsidyGroupIdList;
            delete para.prioritizeSubsidyBalance;
            if (String(this.editForm.TouchTypeDirection || '') === '2') {
              para.PrioritizeSubsidyBalance = false;
              para.SubsidyGroupIds = '';
            } else {
              para.PrioritizeSubsidyBalance = !!this.editForm.prioritizeSubsidyBalance;
              para.SubsidyGroupIds = (this.editForm.subsidyGroupIdList || [])
                .map((x) => String(x == null ? '' : x).trim())
                .filter((x) => x.length > 0)
                .join(',');
            }

            editKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            delete para.subsidyGroupIdList;
            delete para.prioritizeSubsidyBalance;
            if (String(this.addForm.TouchTypeDirection || '') === '2') {
              para.PrioritizeSubsidyBalance = false;
              para.SubsidyGroupIds = '';
            } else {
              para.PrioritizeSubsidyBalance = !!this.addForm.prioritizeSubsidyBalance;
              para.SubsidyGroupIds = (this.addForm.subsidyGroupIdList || [])
                .map((x) => String(x == null ? '' : x).trim())
                .filter((x) => x.length > 0)
                .join(',');
            }

            addKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

    handleSyucUser() {
      if (!this.ensurePersonScopeDevices()) return;
      this.openPersonScopeDialog('sync');
    },

    handleDelUser() {
      if (!this.ensurePersonScopeDevices()) return;
      this.openPersonScopeDialog('delete');
    },

    /** 校验已选终端数量（1~5）。最后更新：2026-09-15 */
    ensurePersonScopeDevices() {
      var rows = this.multipleSelection;
      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备操作！',
          type: 'error',
        });
        return false;
      }
      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error',
        });
        return false;
      }
      return true;
    },

    /** 打开同步/删除人员弹窗（家校/内部通讯录）。最后更新：2026-10-29 */
    openPersonScopeDialog(mode) {
      this.personScopeMode = mode;
      this.personScopeDirectoryScope = 'teaching';
      this.personScopeDeptFilter = '';
      this.personScopeNameFilter = '';
      this.personScopeLiveTypeFilter = '';
      this.personScopeTeachingTree = [];
      this.personScopeInternalTree = [];
      this.personScopeTeachingExpandedKeys = [];
      this.personScopeInternalExpandedKeys = [];
      this.personScopeActiveDeptId = '';
      this.personScopeActiveDeptName = '';
      this.personScopeTableRows = [];
      this.personScopePage = 1;
      this.personScopeSelectedMap = {};
      this.personScopeCheckedCount = 0;
      this.personScopeDeptCount = 0;
      this.personScopeVisible = true;
      this.loadPersonScopeDirectoryTrees();
      this.loadPersonScopeLiveTypeOptions();
      this.$nextTick(() => {
        this.syncPersonScopeTableHeight();
      });
    },

    resetPersonScopeDialog() {
      this.unbindPersonScopeResize();
      this.personScopeDeptFilter = '';
      this.personScopeNameFilter = '';
      this.personScopeLiveTypeFilter = '';
      this.personScopeLiveTypeOptions = [];
      this.personScopeLiveTypeLoading = false;
      this.personScopeTeachingTree = [];
      this.personScopeInternalTree = [];
      this.personScopeTeachingExpandedKeys = [];
      this.personScopeInternalExpandedKeys = [];
      this.personScopeActiveDeptId = '';
      this.personScopeActiveDeptName = '';
      this.personScopeTableRows = [];
      this.personScopePage = 1;
      this.personScopeTableHeight = 400;
      this.personScopeSelectedMap = {};
      this.personScopeCheckedCount = 0;
      this.personScopeDeptCount = 0;
      this.personScopeSyncingTable = false;
      this.personScopeTableLoading = false;
      this.addLoading = false;
    },

    /** 右侧表格高度随可用区域自适应，避免底部留白。最后更新：2026-09-15 */
    syncPersonScopeTableHeight() {
      const measure = () => {
        const wrap = this.$refs.personScopeTableWrap;
        if (!wrap) return;
        const h = Math.floor(wrap.clientHeight);
        if (h > 120 && h !== this.personScopeTableHeight) {
          this.personScopeTableHeight = h;
          this.$nextTick(() => {
            if (this.$refs.personScopeTable && this.$refs.personScopeTable.doLayout) {
              this.$refs.personScopeTable.doLayout();
            }
          });
        }
      };
      this.$nextTick(() => {
        measure();
        setTimeout(measure, 60);
      });
      this.bindPersonScopeResize();
    },

    bindPersonScopeResize() {
      if (this._personScopeResizeBound) return;
      this._personScopeOnResize = () => {
        this.syncPersonScopeTableHeight();
      };
      window.addEventListener('resize', this._personScopeOnResize);
      this._personScopeResizeBound = true;
    },

    unbindPersonScopeResize() {
      if (this._personScopeOnResize) {
        window.removeEventListener('resize', this._personScopeOnResize);
        this._personScopeOnResize = null;
      }
      this._personScopeResizeBound = false;
    },

    /** 规范化通讯录树根节点。最后更新：2026-09-15 */
    normalizePersonScopeTreeRoot(root) {
      if (!root) return [];
      if (Number(root.value || 0) === 0 && root.children && root.children.length) {
        return root.children;
      }
      return [root];
    },

    firstPersonScopeTreeKey(nodes) {
      if (!nodes || !nodes.length) return '';
      const first = nodes[0];
      return first && first.value != null ? String(first.value) : '';
    },

    loadPersonScopeDirectoryTrees() {
      this.personScopeTreeLoading = true;
      const scopeId = this.DepartmentId || 0;
      const p1 = getTeachingDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
        .then((res) => {
          this.personScopeTeachingTree = this.normalizePersonScopeTreeRoot(res && res.data && res.data.response);
          const key = this.firstPersonScopeTreeKey(this.personScopeTeachingTree);
          this.personScopeTeachingExpandedKeys = key ? [key] : [];
        })
        .catch(() => {
          this.personScopeTeachingTree = [];
        });
      const p2 = getInternalDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
        .then((res) => {
          this.personScopeInternalTree = this.normalizePersonScopeTreeRoot(res && res.data && res.data.response);
          const key = this.firstPersonScopeTreeKey(this.personScopeInternalTree);
          this.personScopeInternalExpandedKeys = key ? [key] : [];
        })
        .catch(() => {
          this.personScopeInternalTree = [];
        });
      Promise.all([p1, p2]).finally(() => {
        this.personScopeTreeLoading = false;
        this.$nextTick(() => this.syncPersonScopeTableHeight());
      });
    },

    setPersonScopeDirectory(scope) {
      if (scope !== 'teaching' && scope !== 'internal') return;
      if (this.personScopeDirectoryScope === scope) return;
      this.personScopeDirectoryScope = scope;
      this.personScopeDeptFilter = '';
      this.personScopeLiveTypeFilter = '';
      if (scope === 'teaching') this.loadPersonScopeLiveTypeOptions();
      else this.personScopeLiveTypeOptions = [];
      this.$nextTick(() => {
        const tree = scope === 'internal'
          ? this.$refs.personScopeInternalTree
          : this.$refs.personScopeTeachingTree;
        if (tree && this.personScopeActiveDeptId) {
          tree.setCurrentKey(this.personScopeActiveDeptId);
        }
        if (this.personScopeActiveDeptId) this.loadPersonScopePeople();
      });
    },

    /** 加载本校人员类型选项。最后更新：2026-10-29 */
    loadPersonScopeLiveTypeOptions() {
      const scopeId = normalizeDeptId(this.DepartmentId);
      if (!scopeId) {
        this.personScopeLiveTypeOptions = [];
        return Promise.resolve();
      }
      this.personScopeLiveTypeLoading = true;
      return fetchStudentLiveTypesByDeptId(scopeId)
        .then((list) => {
          this.personScopeLiveTypeOptions = list || [];
          if (
            this.personScopeLiveTypeFilter
            && !(list || []).some((t) => String(t.LiveTypeId) === String(this.personScopeLiveTypeFilter))
          ) {
            this.personScopeLiveTypeFilter = '';
          }
        })
        .catch(() => {
          this.personScopeLiveTypeOptions = [];
        })
        .finally(() => {
          this.personScopeLiveTypeLoading = false;
        });
    },
    onPersonScopeLiveTypeFilterChange() {
      if (this.personScopeActiveDeptId) this.loadPersonScopePeople();
    },
    personScopeRowTypeLabel(row) {
      if (!row) return '—';
      if (row.personType === 'teacher') return '教职工';
      return (row.liveTypeName || '').trim() || '学生';
    },
    personScopeRowTypeTone(row) {
      if (!row) return 'default';
      if (row.personType === 'teacher') return 'teacher';
      const id = String(row.liveTypeId || '').trim().toLowerCase();
      const name = String(row.liveTypeName || '').trim();
      if (id === 'live_school' || /住校/.test(name)) return 'school';
      if (id === 'live_home_spe' || /半通|特殊走读|特走/.test(name)) return 'homeSpe';
      if (id === 'live_home' || id.indexOf('live_home') === 0 || /走读|通校/.test(name)) return 'home';
      if (!id && !name) return 'default';
      let hash = 0;
      const key = id || name;
      for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
      const tones = ['toneA', 'toneB', 'toneC', 'toneD'];
      return tones[hash % tones.length];
    },

    filterPersonScopeDeptNode(value, data) {
      if (!value) return true;
      const keyword = String(value).trim().toLowerCase();
      if (!keyword) return true;
      return String(data.label || data.Name || '').toLowerCase().indexOf(keyword) !== -1;
    },

    personScopeNodeTone(data) {
      if (!data) return 'default';
      const type = String(data.DeptOrgType || data.deptOrgType || '').toLowerCase();
      if (type === 'platform') return 'platform';
      if (type === 'allschools' || type === 'school' || type === 'affiliateschool') return 'school';
      if (type === 'campus') return 'campus';
      if (type === 'period' || type === 'stage') return 'period';
      if (type === 'grade') return 'grade';
      if (type === 'class') return 'class';
      if (data.BigType === 0 || data.bigType === 0) return 'internal';
      return 'default';
    },

    onPersonScopeDeptClick(data) {
      const id = data && (data.value != null ? data.value : data.Id);
      if (id == null || Number(id) <= 0) {
        this.$message.warning('请选择具体部门');
        return;
      }
      this.personScopeActiveDeptId = String(id);
      this.personScopeActiveDeptName = data.label || data.Name || '';
      this.personScopeNameFilter = '';
      this.personScopePage = 1;
      this.loadPersonScopePeople();
    },

    /** 按当前通讯录范围加载人员（不分页截断，右侧表格本地分页）。最后更新：2026-09-15 */
    loadPersonScopePeople() {
      const deptId = this.personScopeActiveDeptId;
      if (!deptId) return;
      this.personScopeTableLoading = true;
      this.personScopePage = 1;
      const name = (this.personScopeNameFilter || '').trim();
      const isTeaching = this.personScopeDirectoryScope === 'teaching';

      const request = isTeaching
        ? (() => {
            const params = { departmentId: deptId, name };
            const lt = (this.personScopeLiveTypeFilter || '').trim();
            if (lt) params.liveTypeId = lt;
            return getStudentSelectList(params).then((res) => {
              const list = (res.data && res.data.response) || [];
              return list.map((s) => ({
                value: String(s.Id),
                label: s.Name || s.StuName || '',
                deptId: String(s.DepartmentId || deptId),
                deptLabel: s.DepartmentName || this.personScopeActiveDeptName,
                scopeDeptId: String(deptId),
                personType: 'student',
                liveTypeId: s.LiveTypeId || s.liveTypeId || '',
                liveTypeName: s.LiveType || s.liveType || s.LiveTypeName || s.liveTypeName || '',
                HeadPhotoImage: s.HeadPhotoImage || ''
              }));
            });
          })()
        : this.loadAllPersonScopeTeachers(deptId, name);

      request.then((rows) => {
        this.personScopeTableRows = rows || [];
        this.$nextTick(() => {
          this.syncPersonScopeTableHeight();
          this.syncPersonScopeTableSelection();
          this.prefetchPersonScopeAvatars();
        });
      }).catch(() => {
        this.personScopeTableRows = [];
      }).finally(() => {
        this.personScopeTableLoading = false;
      });
    },

    /** 内部通讯录教职工：按页拉全量，避免 intPageSize 截断。最后更新：2026-09-15 */
    async loadAllPersonScopeTeachers(deptId, name) {
      const pageSize = 500;
      let page = 1;
      let total = 0;
      const all = [];
      do {
        const res = await getTeacherMasterListPage({
          page,
          departmentId: deptId,
          intPageSize: pageSize,
          teacherName: name
        });
        const pageData = (res.data && res.data.response) || {};
        const list = pageData.data || [];
        total = pageData.dataCount || list.length;
        list.forEach((t) => {
          all.push({
            value: String(t.Id),
            label: t.TeacherName || t.Name || '',
            deptId: String(t.DepartmentId || deptId),
            deptLabel: t.DepartmentName || t.ContextDepartmentName || t.DefaultDepartmentName || this.personScopeActiveDeptName,
            scopeDeptId: String(deptId),
            personType: 'teacher',
            HeadPhotoImage: t.HeadPhotoImage || ''
          });
        });
        if (!list.length || all.length >= total) break;
        page += 1;
      } while (page <= 200);
      return all;
    },

    handlePersonScopePageChange(page) {
      // 先锁住 selection-change，避免翻页时空选清掉当页已选。最后更新：2026-10-29
      lockPersonScopeSelectionSync(this);
      this.personScopePage = page;
      this.$nextTick(() => {
        this.syncPersonScopeTableSelection();
        this.prefetchPersonScopeAvatars();
      });
    },

    /** 当前页头像 OSS 预签。最后更新：2026-09-15 */
    prefetchPersonScopeAvatars() {
      const rows = this.personScopePagedRows || [];
      if (!rows.length) return;
      this.prefetchListOssMedia(rows, 'HeadPhotoImage');
    },

    /** 按已选 Map 回显当前表格勾选。最后更新：2026-10-29 */
    syncPersonScopeTableSelection() {
      syncPersonScopeElTableSelection({
        vm: this,
        tableRef: 'personScopeTable',
        rows: this.personScopePagedRows || [],
        isSelected: (row) => !!this.personScopeSelectedMap[row.value],
      });
    },

    /** 点击行切换勾选。最后更新：2026-09-15 */
    onPersonScopeRowClick(row, column, event) {
      // 点在复选框上时，交给表格自身 selection-change，避免重复切换
      if (event && event.target) {
        const target = event.target;
        if (
          target.classList.contains('el-checkbox__original') ||
          target.classList.contains('el-checkbox__inner') ||
          (target.closest && target.closest('.el-checkbox'))
        ) {
          return;
        }
      }
      const table = this.$refs.personScopeTable;
      if (!table || !row) return;
      table.toggleRowSelection(row);
    },

    onPersonScopeTableSelectionChange(selection) {
      if (this.personScopeSyncingTable) return;
      const selectedIds = {};
      (selection || []).forEach((row) => {
        selectedIds[row.value] = true;
      });
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      // 只更新当前页可见行，避免翻页误清其他页已选
      (this.personScopePagedRows || []).forEach((row) => {
        if (selectedIds[row.value]) {
          nextMap[row.value] = {
            value: row.value,
            label: row.label,
            deptId: row.deptId,
            deptLabel: row.deptLabel,
            scopeDeptId: row.scopeDeptId,
            personType: row.personType
          };
        } else {
          delete nextMap[row.value];
        }
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
    },

    selectAllPersonScopeCurrentDept() {
      const people = this.personScopeTableRows || [];
      if (!people.length) return;
      lockPersonScopeSelectionSync(this);
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      people.forEach((row) => {
        nextMap[row.value] = {
          value: row.value,
          label: row.label,
          deptId: row.deptId,
          deptLabel: row.deptLabel,
          scopeDeptId: row.scopeDeptId,
          personType: row.personType
        };
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },

    clearPersonScopeCurrentDept() {
      lockPersonScopeSelectionSync(this);
      const scopeId = String(this.personScopeActiveDeptId || '');
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      Object.keys(nextMap).forEach((k) => {
        const row = nextMap[k];
        if (String(row.scopeDeptId || row.deptId) === scopeId) delete nextMap[k];
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },

    clearPersonScopeSelection() {
      lockPersonScopeSelectionSync(this);
      this.personScopeSelectedMap = {};
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },

    refreshPersonScopeSummary() {
      const list = Object.keys(this.personScopeSelectedMap || {}).map((k) => this.personScopeSelectedMap[k]);
      this.personScopeCheckedCount = list.length;
      const deptSet = {};
      list.forEach((n) => {
        if (n && n.deptId != null) deptSet[String(n.deptId)] = true;
      });
      this.personScopeDeptCount = Object.keys(deptSet).length;
    },

    collectPersonScopeUserIds() {
      return Object.keys(this.personScopeSelectedMap || {}).map((k) => {
        const n = this.personScopeSelectedMap[k];
        return [String(n.deptId), String(n.value)];
      });
    },

    submitPersonScopeSelected() {
      if (!this.ensurePersonScopeDevices()) return;
      const userIds = this.collectPersonScopeUserIds();
      if (!userIds.length) {
        this.$message({
          message: this.personScopeMode === 'delete' ? '请先勾选要删除的人员' : '请先勾选要同步的人员',
          type: 'warning',
        });
        return;
      }
      const tip = this.personScopeMode === 'delete'
        ? `确认删除选中的 ${userIds.length} 人（涉及 ${this.personScopeDeptCount} 个部门）吗？`
        : `确认同步选中的 ${userIds.length} 人（涉及 ${this.personScopeDeptCount} 个部门）吗？`;
      this.confirmAndSubmitPersonScope(tip, userIds);
    },

    submitPersonScopeAll() {
      if (!this.ensurePersonScopeDevices()) return;
      const tip = this.personScopeMode === 'delete'
        ? '确认清空所选终端的全部人员吗？此操作将按设备所属部门范围全量删除。'
        : '确认对所选终端进行全量同步吗？将下发设备所属部门范围内全部有头像人员。';
      this.confirmAndSubmitPersonScope(tip, []);
    },

    confirmAndSubmitPersonScope(confirmText, userIds) {
      const way = this.personScopeMode === 'delete' ? '2' : '0';
      const deviceNos = this.multipleSelection.map((e) => e.KqTerminalId);
      const para = {
        deviceNos,
        way,
        userIds: userIds || []
      };
      this.$confirm(confirmText, '提示', {
        type: 'warning',
      }).then(() => {
        this.addLoading = true;
        syucUser(para).then((res) => {
          this.addLoading = false;
          if (res.data.success) {
            this.$message({
              message: this.personScopeMode === 'delete' ? '删除指令已下发' : '同步指令已下发',
              type: 'success',
            });
            this.personScopeVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
            });
          }
        }).catch(() => {
          this.addLoading = false;
        });
      }).catch(() => { });
    },
  },
  computed: {
    personScopeCurrentTreeEmpty() {
      const tree = this.personScopeDirectoryScope === 'internal'
        ? this.personScopeInternalTree
        : this.personScopeTeachingTree;
      return !tree || !tree.length;
    },
    personScopePagedRows() {
      const rows = this.personScopeTableRows || [];
      const size = this.personScopePageSize || 10;
      const page = this.personScopePage || 1;
      const start = (page - 1) * size;
      return rows.slice(start, start + size);
    }
  },
  watch: {
    personScopeDeptFilter(val) {
      const tree = this.personScopeDirectoryScope === 'internal'
        ? this.$refs.personScopeInternalTree
        : this.$refs.personScopeTeachingTree;
      if (tree) tree.filter(val);
    }
  },
  beforeDestroy() {
    this.unbindPersonScopeResize();
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.mode-tag-sub {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  min-height: 40px;
  padding: 2px 0;
  min-width: 0;
}

.cell-main {
  color: #303133;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: center;
}

.cell-meta {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-align: center;
}

.tag-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.op-link {
  color: var(--btn-primary, #2563eb);
}

/* 固定金额：标签固定两行，避免 label 区过窄时「金」「额」被拆开 */
.terminal-dialog-form>>>.terminal-form-item--fixed-amount-label .el-form-item__label {
  white-space: normal;
  line-height: 1.35;
  height: auto;
}

.terminal-dialog-form>>>.terminal-fixed-amount-label {
  display: inline-block;
  text-align: right;
}

/* 工具栏与表格间距（整块 el-col.toolbar） */
.page-consumption-terminal>>>.toolbar {
  margin-bottom: 16px;
}

/* 筛选项包在 span 内，与后面「查询」等按钮紧贴；给搜索区右侧留白 */
.page-consumption-terminal>>>.toolbar .el-form--inline>span {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 14px;
}

/* 工具栏：压缩筛选项宽度，按钮自然换行，避免出现横向滚动条 */
.page-consumption-terminal>>>.toolbar .el-form--inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 8px;
  column-gap: 0;
}

.page-consumption-terminal>>>.toolbar .el-form--inline .el-form-item {
  margin-bottom: 0;
  margin-right: 10px;
  vertical-align: middle;
}

.page-consumption-terminal>>>.toolbar .el-form-item:last-child {
  margin-right: 0;
}

.consumption-terminal-table >>> .el-table__body tr {
  cursor: pointer;
}

.consumption-terminal-table >>> .el-table td,
.consumption-terminal-table >>> .el-table th {
  vertical-align: middle;
}

.consumption-terminal-table >>> .el-table .cell {
  line-height: 20px;
  padding-left: 12px;
  padding-right: 12px;
}

.consumption-terminal-table >>> .el-tag--mini {
  height: 22px;
  line-height: 20px;
  padding: 0 8px;
}

/* 同步日志弹窗：状态与「搜索」按钮之间留白 */
.sync-log-form-actions-lead {
  margin-left: 14px;
}

.sync-log-filter-form.el-form--inline .el-form-item {
  margin-right: 8px;
}

/* 弹窗底部分页：占满一行再 flex-end；不要 border-top，避免与 el-table 底边叠成双线 */
.sync-log-pager-wrap {
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
  padding-top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}

/* 同步/删除人员：固定高度，左侧树内部滚动（对齐头像压缩弹窗）。最后更新：2026-09-15 */
.ps-layout {
  display: flex;
  gap: 0;
  height: 640px;
  max-height: calc(90vh - 140px);
  min-height: 420px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.ps-left {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e2e8f0;
  background: #fff;
  min-height: 0;
  overflow: hidden;
}
.ps-left-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex-shrink: 0;
}
.ps-left-header i {
  color: var(--btn-primary, #2563eb);
}
.ps-scope-bar {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 0 12px 10px;
  flex-shrink: 0;
}
.ps-scope-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.ps-scope-btn:hover {
  border-color: #bfdbfe;
  color: #2563eb;
}
.ps-scope-btn.is-active {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1d4ed8;
  font-weight: 600;
}
.ps-left-search {
  padding: 0 12px 10px;
  flex-shrink: 0;
}
.ps-left-search >>> .el-input__inner {
  border-radius: 6px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
}
.ps-left-search >>> .el-input__inner:focus {
  border-color: #2563eb;
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}
.ps-left-tree {
  flex: 1 1 0;
  min-height: 0;
  height: 0; /* 与头像压缩一致：树展开只在左侧内部滚动，不撑高弹窗 */
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 8px 12px;
  position: relative;
  box-sizing: border-box;
}
.ps-left-tree >>> .el-tree {
  background: transparent;
  color: #1e293b;
  height: auto !important;
}
.ps-left-tree >>> .el-tree-node__content {
  height: 34px;
  border-radius: 6px;
  margin-bottom: 1px;
}
.ps-left-tree >>> .el-tree-node.is-current > .el-tree-node__content {
  background: #dbeafe;
}
.ps-tree-node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 24px);
  min-width: 0;
}
.ps-tree-node__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #94a3b8;
}
.ps-tree-node__dot.tone-school { background: var(--btn-primary, #2563eb); }
.ps-tree-node__dot.tone-campus { background: #f59e0b; }
.ps-tree-node__dot.tone-period { background: #8b5cf6; }
.ps-tree-node__dot.tone-grade { background: #06b6d4; }
.ps-tree-node__dot.tone-class { background: #64748b; }
.ps-tree-node__dot.tone-platform { background: #f59e0b; }
.ps-tree-node__dot.tone-internal { background: #0ea5e9; }
.ps-tree-node__dot.tone-default { background: #94a3b8; }
.ps-tree-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
  font-size: 13px;
}
.ps-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
.ps-right {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 14px;
  background: #fff;
  overflow: hidden;
}
.ps-alert {
  margin-bottom: 10px;
  flex-shrink: 0;
}
.ps-meta {
  margin-bottom: 10px;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
  flex-shrink: 0;
}
.ps-meta-sep {
  margin: 0 6px;
  color: #cbd5e1;
}
.ps-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-name-input {
  width: 160px;
}
.ps-type-select {
  width: 140px;
}
.ps-type-tag {
  display: inline-block;
  max-width: 100%;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 20px;
  border: 1px solid transparent;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.ps-type-tag--teacher {
  color: #b45309;
  background: #fffbeb;
  border-color: #fcd34d;
}
.ps-type-tag--school {
  color: #047857;
  background: #ecfdf5;
  border-color: #6ee7b7;
}
.ps-type-tag--home {
  color: #1d4ed8;
  background: #eff6ff;
  border-color: #93c5fd;
}
.ps-type-tag--homeSpe {
  color: #c2410c;
  background: #fff7ed;
  border-color: #fdba74;
}
.ps-type-tag--default {
  color: #64748b;
  background: #f8fafc;
  border-color: #e2e8f0;
}
.ps-type-tag--toneA {
  color: #6d28d9;
  background: #f5f3ff;
  border-color: #c4b5fd;
}
.ps-type-tag--toneB {
  color: #0e7490;
  background: #ecfeff;
  border-color: #67e8f9;
}
.ps-type-tag--toneC {
  color: #be185d;
  background: #fdf2f8;
  border-color: #f9a8d4;
}
.ps-type-tag--toneD {
  color: #4338ca;
  background: #eef2ff;
  border-color: #a5b4fc;
}
.ps-hint {
  font-size: 13px;
  color: #475569;
  margin-bottom: 8px;
  line-height: 1.5;
  flex-shrink: 0;
}
.ps-hint-sub {
  color: #64748b;
  margin-left: 4px;
}
.ps-hint--warn {
  color: #b45309;
}
.ps-table-wrap {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  margin-bottom: 8px;
  overflow: hidden;
}
.ps-table-wrap >>> .el-table {
  width: 100%;
}
.ps-table-wrap >>> .el-table__body tr {
  cursor: pointer;
}
.ps-avatar-empty {
  color: #c0c4cc;
  font-size: 12px;
}
.ps-pager-wrap {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.ps-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 4px;
  flex-shrink: 0;
}
</style>
